import { render, staticRenderFns } from "./house.vue?vue&type=template&id=fc19a14c&scoped=true"
import script from "./house.vue?vue&type=script&lang=js"
export * from "./house.vue?vue&type=script&lang=js"
import style0 from "./house.vue?vue&type=style&index=0&id=fc19a14c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc19a14c",
  null
  
)

export default component.exports